export const getWordPressBaseUrl = () =>
  (process.env.REACT_APP_WORDPRESS_URL || "").replace(/\/$/, "");

export const getLoginMarketingLinks = () => {
  const base = getWordPressBaseUrl();
  if (!base) {
    return {
      home: "/",
      howItWorks: "#",
      aboutUs: "#",
      faq: "#",
      contact: "#",
      getStarted: "#",
      signUp: "#",
      forgotPassword: "#",
      wpLogin: "#",
      cookieStatement: "#",
      privacyPolicy: "#",
      terms: "#",
    };
  }

  return {
    home: `${base}/`,
    howItWorks: `${base}/how-it-works/`,
    aboutUs: `${base}/about-us/`,
    faq: `${base}/faq/`,
    contact: `${base}/contact-us/`,
    getStarted: `${base}/signup/`,
    signUp: `${base}/signup/`,
    forgotPassword: `${base}/password-reset/`,
    wpLogin: `${base}/login/`,
    cookieStatement: `${base}/cookie-statement/`,
    privacyPolicy: `${base}/privacy-policy/`,
    terms: `${base}/terms-conditions/`,
  };
};

export const GRADIENT_BUTTON_STYLE = {
  background: "linear-gradient(150deg, #0771EF 12.89%, #15AAFC 85.22%)",
};
